import React from 'react';
import { useInstantSearch } from 'react-instantsearch';
import Hits from '../Hits';

const StateResults = ({ searchState }) => {
    const { indexUiState } = useInstantSearch();

    return <>{indexUiState.query && <Hits />}</>;
};

export default StateResults;
